import authCodeMap from "@/dataBase/authCodeMap";
const routes = [{
  path: "/",
  name: "index",
  component: () => import("@/modules/router.vue"),
  redirect: "/index",
  meta: {
    hidden: true,
    needLogin: false,
    title: ""
  },
  children: [{
    path: "/home",
    name: authCodeMap.home,
    component: () => import("@/modules/home/pages/index.vue"),
    meta: {
      hidden: true,
      needLogin: true,
      title: "社区首页"
    }
  }, {
    path: "/hc-home",
    name: authCodeMap.hc_home,
    component: () => import("@/modules/home/pages/hcIndex.vue"),
    meta: {
      hidden: true,
      needLogin: true,
      title: "社区首页"
    }
  }, {
    path: "/doctor_community_home",
    name: authCodeMap.doctor_community_home,
    component: () => import("@/modules/home/pages/doctor_community_home.vue"),
    meta: {
      hidden: true,
      needLogin: true,
      title: "社区首页"
    }
  }]
}];
export default routes;